import React, { useState, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { home, search, download} from 'ionicons/icons';
import { isPlatform } from '@ionic/react';
import { Plugins } from '@capacitor/core';

import { AppContext, AppContextInterface  } from './AppContext';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './pages/css/common.css';

/* Pages */
import AddEditActivity from './pages/AddEditActivity';
import Search from './pages/Search';
import Download from './pages/Download';
import Login from './pages/Login';
import ExternalLogin from './pages/ExternalLogin';
import Home from './pages/Home';
import ExternalHome from './pages/ExternalHome';
import Results from './pages/Results';
import WatchResults from './pages/WatchResults';
import RecentResults from './pages/RecentResults';
import Logout from './pages/Logout';

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

//import { isJSDocNullableType } from 'typescript';
//delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const { Geolocation, Network } = Plugins;

const App: React.FC = () => {
  //const { networkStatus } = useStatus();
  const [, setStatus] = useState<any>();
  const [appState, setAppState] = useState<AppContextInterface>({
    latitude: null,
    longitude: null,
    pinValue: 0,
    recentValue: 0, 
    singleClient: false 
  });

  useEffect(() => {
    Geolocation.getCurrentPosition().then((position) => {
      setAppState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        pinValue: 0, 
        recentValue: 0,
        singleClient: false
      });
    }, (err) => {});
    getStatus();   
  }, []);
  
  const getStatus = async() => {
    try {
      let _status = await Network.getStatus();
      setStatus(_status);
    } 
    catch (e) { console.log("Error", e) }
  }

  return (
    <AppContext.Provider value={appState}>
      <IonApp>
        <IonReactRouter>
          <Switch>
            {/* <IonRouterOutlet> */}
              <Route path="/login" component={Login} />
              <Route path="/externalLogin/:usr/:cId/:id/:permitId/:mooringId/:personId/:boatId" component={ExternalLogin}/>
              <Route path="/externalHome/:cId/:permitId/:mooringId/:personId/:boatId" component={ExternalHome}/>
              <Route path="/activity/:id/:clientId/:type/:isExternal/:permitId/:mooringId/:personId/:boatId" component={AddEditActivity} />
              <Route path="/results" component={Results} exact={true} />
              <Route path="/watchresults" component={WatchResults} exact={true} />
              <Route path="/recentresults" component={RecentResults} exact={true} />
              <Route path="/logout" component={Logout} exact={true} />
              <Redirect exact from="/" to="/login" />
            {/* </IonRouterOutlet> */}
            <IonTabs>
                <IonRouterOutlet>
                  <Route path="/home" component={Home} exact ={true}/>
                  <Route path="/search" component={Search} exact={true} />
                  <Route path="/download" component={Download} exact={true} />
                </IonRouterOutlet>
                <IonTabBar slot="bottom" className={isPlatform('ios') ? "my-ion-tabbar-ios" :"my-ion-tabbar"}>
                  <IonTabButton tab="home" href="/home">
                    <IonIcon icon={home} />
                    <IonLabel>Home</IonLabel>
                  </IonTabButton>
                  <IonTabButton tab="search" href="/search">
                    <IonIcon icon={search} />
                    <IonLabel>Search</IonLabel>
                  </IonTabButton>
                  <IonTabButton tab="download" href="/download">
                    <IonIcon icon={download} />
                    <IonLabel>Download</IonLabel>
                  </IonTabButton>
                </IonTabBar>
            </IonTabs> 
        </Switch>
      </IonReactRouter>
    </IonApp>
  </AppContext.Provider>
)};

export default App;
